import { fromFetch } from 'rxjs/fetch';

import { AuthHeaders } from '../../../models/auth-headers';
import { dataAccessEnvironment } from '../../../models/data-access-environment';
import { requiredHeaders } from '../../../models/required-headers';
import { UserPagedCollectionParams } from '../../../models/user-paged-collection-params';
import { selectData } from '../../../utils/select-data';
import { withJwt } from '../../../utils/with-jwt';
import { accountsEnvironment } from '../accounts-environment';
import { AddOn } from '../public-api';
import { jobTraceIdResponseSchema } from '../schemas/job-trace-id-response.schema';

/**
 * Submists a license assignment operation (assign/unassign) for filtered assets based on fleet info criteria.
 * @param licenseOperation Use 'Assign' to assign the product and 'Unassign' to unassign the product
 * @param params User Paged Collection Params
 * @param productId ID of the product to assign
 * @param addons Array of AddOns
 * @returns The job trace ID
 */
export function postBulkAssetLicense(
  this: unknown,
  licenseOperation: 'Assign' | 'Unassign',
  params: UserPagedCollectionParams,
  productId: number,
  addons: AddOn[],
  assetIds: string[]
) {
  return withJwt((jwtAuthHeaders) =>
    fromFetch(
      new Request(
        `${accountsEnvironment.resolve(this).bulkAssetLicenseUrl()}?${params.urlParams}`,
        {
          method: 'POST',
          headers: {
            ...requiredHeaders,
            ...(dataAccessEnvironment.configuration.useLegacyTokenForAccountsApi
              ? new AuthHeaders()
              : jwtAuthHeaders),
          },
          body: JSON.stringify({
            licenseDetails: {
              productId,
              addons,
            },
            licenseOperation,
            assetIds: assetIds.length > 0 ? assetIds : undefined,
          }),
        }
      )
    )
  ).pipe(selectData(jobTraceIdResponseSchema));
}
